import React from "react";

import InsurersDataTable from "./InsurersDataTable";
import { EnumWrapper } from "../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../utils/enums/enums";

const InsurersPage = () => {
  return (
    <div className="sub-content">
      <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
        <InsurersDataTable />
      </EnumWrapper>
    </div>
  );
};

export default InsurersPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/insurers/InsurersPage.js